import reducer, * as fromProductAreas from './reducer';

export * from './actions';
export { watchFetchProductAreas } from './saga';
export { fromProductAreas };
export default reducer;
